<template>
  <div class="client-item-box new-product-box" :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex" :data-trackdata="tData">
    <!-- <div class="new-title" v-if="!hideTitle">NEW ARRIVAL</div> -->
    <div class="new-title" v-if="data.showTitle === 'SHOW'">NEW ARRIVAL</div>
    <div class="products-wrap" v-if="products">
      <div class="items-wrap" :id="'newBox' + modIndex">
        <div class="items">
          <div class="item" v-for="(p, index) in products" :key="p.id" @click="productAction(p, index)">
            <div class="single-img-box">
              <beast-image class="single-img" 
                :lazy="true"
                :defaultImage="defaultImage"
                :src="p.featureImage" 
              />
            </div>
            <div class="brand">{{p.brand?p.brand.name:''}}</div>
          </div>
          <div class="show-more-box" v-if="showMoreFlag">
            <div class="show-more" v-if="showMoreFlag" @click="showMoreAction">查看更多<span class="arrow"></span></div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import iScroll from '@/iscroll'
import BScroll from 'better-scroll'
import { lazyload } from '@/lazyload'
import { ensure_protocol } from '@beastshop/url-util'
import { axiosAction, getImages, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getLinkPageData } from '@/link'

import beastImage from '@/components/image'

const images = getImages()

export default {
  name: 'article-new',
  props: ['data', 'modIndex', 'hideTitle'],
  data () {
    return {
      defaultImage: ensure_protocol(images['defaultImage']),
      products: null,
      showMoreFlag: false,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  components: {
    beastImage
  },
  mounted () {
  },
  computed: {
  },
  created () {
    this.getProductData()
  },
  methods: {
    getProductData () {
      let arr = []
      for(let i=0;i<5;i++) {
        arr.push(i)
      }
      this.products = arr

      // console.log(this.products, "getProductData")
      return axiosAction({
        url: `/app/article/newProduct`,
        method: 'POST',
        param: this.data.codes || []
      })
      .then((data) => {
        // console.log(data, "getProductData data")
        if(data) {
          let products = data.products
          products.forEach((p, index) => {
            products[index].featureImage = ensure_protocol(p.cropFeatureImage || p.featureImage || p.images[0])
            products[index].brandName = p.brand?(p.brand.name?p.brand.name:''):''
          })
          this.$nextTick(() => {
            this.products = products
            this.showMoreFlag = data.showMore

            // this.$nextTick(() => {
            //   lazyload()
            // })
            setTimeout(() => {
              lazyload()
            }, 100)

            // let scroll = new BScroll(`#newBox${this.newIndex}`, {
            //   scrollY: false,
            //   scrollX: true,
            //   click: true,
            //   bounce: {
            //     left: false,
            //     right: false
            //   }
            // })

          })
        }
      })
      .catch(err => {
        console.log(err || 'getProductData出错啦')
        return
      })
    },
    productAction (p, index) {
      if(!p.id) {
        return
      }
      // this.skipLink({
      //   link: {
      //     type: 'product',
      //     value: p.id
      //   },
      //   trackAttr: {
      //     name: 'new-product',
      //     attrs: {
      //       index: `${this.newIndex}-${index}`,
      //       name: p.name
      //     },
      //     wait: false
      //   }
      // })

      sa.track('CommodityClick', {
        position_number: index-0+1,
        commodity_spu_id: p.id,
        commodity_name: p.name,
        original_price: p.rawPrice,
        discount_price: p.price,
        commodity_need_point: p.point || 0,
        business_case: '其他'
      })

      const link = {
        type: 'product',
        value: p.id
      }
      const myLink = transformLink({
        link,
        title: p.name
      })
      const trackData = this.data.trackData
      trackData.module_number = index-0+1
      trackData.operation_name = p.name
      trackAction({
        trackData,
        pageObj: getLinkPageData({link, title: p.name})
      })

      normalSkip({
        link: myLink
      })
    },
    
    showMoreAction () {
      // this.skipLink({
      //   link: {
      //     type: 'new',
      //     value: ''
      //   },
      //   trackAttr: {
      //     name: 'new-product-show-more',
      //     attrs: {
      //       index: `${this.newIndex}-${this.products.length}`,
      //       name: '查看全部'
      //     },
      //     wait: false
      //   }
      // })
      const link = {
        type: 'new',
        value: ''
      }
      const myLink = transformLink({
        link,
        title: '新鲜上架'
      })
      const trackData = this.data.trackData
      trackData.module_number = this.products.length+1
      trackData.operation_name = '查看更多'
      trackAction({
        trackData,
        pageObj: getLinkPageData({link, title: '新鲜上架'})
      })

      normalSkip({
        link: myLink
      })
    },

    // skipLink ({link, title, trackAttr}) {
    //   let setLink = transformLink({
    //     link,
    //     title
    //   })
    //   trackSkip({
    //     trackData: trackAttr,
    //     link: setLink
    //   })
    // },

  }
}
</script>



// WEBPACK FOOTER //
// new.vue?e0690bf8